import { Injectable, inject } from '@angular/core';
import { CustomerStatistics } from './analytics-models';
import { TriggerbeeApi } from '../../core/triggerbee/triggerbee-requester.service';
import { HttpRequestDecorator } from 'app/core/triggerbee/http.request.decorator';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import {
  DpSignUpCountBySiteResponse,
  buildSignUpCountRequest,
  mapSignUpCountBySiteResponse,
} from './data-platform-adapters/signup-analytics.adapter';

const LIFETIME_FROM = '1990-01-01T06:59:30.308Z';

@Injectable()
export class AnalyticsService {
  private readonly http = inject(HttpRequestDecorator);

  public getCustomerStatistics(customerId: string, startDate: Date, endDate: Date): Observable<CustomerStatistics> {
    const url = `${this.http.getBaseUrl(TriggerbeeApi.Gateway)}/statistics/customers/${customerId}`;
    return this.http.get(url, {
      startDate: this.formatDate(startDate),
      endDate: this.formatDate(endDate),
    });
  }

  public getCustomerStatisticsForAdmin(
    customerId: string,
    startDate: Date,
    endDate: Date,
  ): Observable<CustomerStatistics> {
    const url = `${this.http.getBaseUrl(TriggerbeeApi.Gateway)}/admin/customers/${customerId}/statistics`;
    return this.http.get(url, {
      startDate: this.formatDate(startDate),
      endDate: this.formatDate(endDate),
    });
  }

  public getSignupAnalyticsCountBySiteIdsFromDataPlatform(
    siteIds: number[],
    endDate: string,
    startDate: string = LIFETIME_FROM,
  ): Observable<unknown> {
    const url = `${this.http.getBaseUrl(TriggerbeeApi.Gateway)}/data-platform/signup-analytics/count-by-site`;
    const body = buildSignUpCountRequest(siteIds, startDate, endDate);
    return this.http
      .post(url, body, { feature: 'client-signup-analytics-count-by-site' })
      .pipe(map((response: DpSignUpCountBySiteResponse) => mapSignUpCountBySiteResponse(response)));
  }

  private formatDate(date: Date) {
    const year = date.getFullYear();
    const month = date.getMonth() + 1;
    const day = date.getDate();
    return `${year}-${month}-${day}`;
  }
}
